<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Room Library</h2>
			<v-btn color="primary" @click="showAdd()">Add Room</v-btn>
		</div>

		<v-row>
			<v-col cols="3">
				<v-autocomplete
					v-model="planFilter"
					chips
					small-chips
					deletable-chips
					label="Filter by plans"
					multiple
					:items="tenantPlanList"
					item-value="id"
					:item-text="(item) => item.name + ' - ' + item.type"
					solo
					dense
				></v-autocomplete>
			</v-col>
			<v-col cols="3">
				<v-autocomplete
					v-model="tagFilter"
					:items="tagList"
					chips
					small-chips
					deletable-chips
					label="Filter by tags"
					multiple
					solo
					dense
				></v-autocomplete>
			</v-col>
			<div style="display: flex; flex-direction: row; margin-top: 13px">
				<v-btn color="primary" style="margin-right: 10px" @click="listRoomLibrary()">filter</v-btn>
				<v-btn color="primary" @click="resetRoomLibraryFilter">Reset</v-btn>
			</div>
		</v-row>

		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover v-for="(entity, index) in roomLibraryList.data" :key="index" v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<v-card-title>
						<span>{{ entity.name }}</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<div id="structure-view" style="display: block">
						<div class="entry-view">
							<v-img
								v-if="entity.backgroundDisplay"
								:src="$root.asset(entity.backgroundDisplay)"
								max-height="200"
								min-height="200"
							></v-img>
							<v-img
								v-else-if="$root.isImage(entity.background)"
								:src="$root.asset(entity.background)"
								max-height="200"
								min-height="200"
							></v-img>
							<video
								v-else-if="$root.isVideo(entity.background)"
								width="100%"
								style="max-height: 200px; min-height: 200px"
								preload="auto"
								autoplay="autoplay"
								muted
								playsinline
								disablepictureinpicture
								loop="loop"
							>
								<source :src="$root.asset(entity.background)" type="video/mp4" />
							</video>
							<template v-else-if="$root.isYoutubeUrl(entity.background)">
								<youtube
									:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
									:player-vars="$root.getYoutubeParams(entity.background)"
									style="pointer-events: none "
									width="340"
									height="200"
									ref="backgroundIndexYoutube"
								></youtube>
							</template>
							<vimeo-player 
								v-else-if="$root.isVimeoUrl(entity.background)"
								:video-url="entity.background"
								:options="backgroundVimeoParams"
								style="pointer-events: none "
								player-width="340"
								player-height="200"
								ref="introTransition"
							></vimeo-player>
							<router-link
								v-for="(item, idx) in entity.linkToDataList"
								:key="idx"
								class="structure-link"
								to="#"
								:style="{
									width: item.width + '%',
									height: item.height + '%',
									top: item.posY + '%',
									left: item.posX + '%',
									transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)'
								}"
							></router-link>
						</div>
					</div>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Room</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showLinkTo(entity)">
									<v-icon>mdi-link-variant-plus</v-icon>
								</v-btn>
							</template>
							<span>Default Banner Slot</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="deleteRoomLibrary(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Room</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>

		<div class="d-flex flex-wrap justify-space-between" style="margin: 0px 20px 0px 30px">
			<div class="d-inline-flex">
				<span style="margin-top: 10px"> Rows per page : </span>
				<v-select
					v-model="roomLibraryList.size"
					:items="rowsPerPage"
					style="margin-left: 10px; width: 80px"
					@change="listRoomLibrary()"
					hide-details=""
					solo
				></v-select>
			</div>

			<v-pagination
				v-model="roomLibraryList.page"
				:length="roomLibraryList.length"
				:total-visible="7"
				@input="listRoomLibrary()"
			></v-pagination>
		</div>

		<v-dialog v-model="dialogAdd" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Room Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formAdd" v-model="valid" @submit.prevent="addRoomLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col class="text-center" cols="12" sm="6">
											<img
												v-if="
													backgroundTemp &&
													backgroundTemp.startsWith('data') &&
													backgroundType == 'Upload' &&
													(backgroundImageName.toLowerCase().endsWith('.jpg') ||
														backgroundImageName.toLowerCase().endsWith('.jpeg') ||
														backgroundImageName.toLowerCase().endsWith('.png'))
												"
												:src="backgroundTemp"
												width="100%"
												height="200px"
											/>
											<img
												v-else-if="entity.background && backgroundType == 'URL' && $root.isImage(entity.background)"
												:src="
													entity.background.toLowerCase().startsWith('http')
														? entity.background
														: baseLocation + '/asset/file/' + entity.background
												"
												width="100%"
												height="200px"
											/>

											<video
												v-else-if="
													backgroundTemp &&
													backgroundType == 'Upload' &&
													backgroundTemp.startsWith('data') &&
													backgroundImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="200px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="backgroundTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="entity.background && backgroundType == 'URL' && $root.isVideo(entity.background)"
												width="100%"
												height="200px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entity.background.toLowerCase().startsWith('http')
															? entity.background
															: baseLocation + '/asset/file/' + entity.background
													"
													type="video/mp4"
												/>
											</video>
											<div v-else-if="entity.background && backgroundType == 'URL' && $root.isYoutubeUrl(entity.background)">
												<youtube
													:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
													:player-vars="backgroundYoutubeParams"
													style="pointer-events: none "
													width="512"
													height="288"
												></youtube>
											</div>
											<vimeo-player 
												v-else-if="entity.background && backgroundType == 'URL'  && $root.isVimeoUrl(entity.background)"
												:video-url="entity.background"
												:options="backgroundVimeoParams"
												style="pointer-events: none "
												player-width="512"
												player-height="288"
												ref="background"
											></vimeo-player>
											<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
											<!---INPUT FOR BACKGROUND--->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Background Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundFileName"
														label="Background"
														hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Background"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Room image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entity.background"
														prepend-icon="mdi-image"
														label="Background"
														placeholder="Background Url"
														hint="Please input image url with jpeg/jpg/png extension or video with mp4 extension"
														:rules="[(v) => !!v || 'Room image is required']"
													></v-text-field> </v-col
											></v-row>
											<!---END INPUT FOR BACKGROUND-->
										</v-col>
										<v-col class="text-center" cols="12" sm="6">
											<img
												v-if="
													introTransitionTemp &&
													introTransitionTemp.startsWith('data') &&
													introTransitionType == 'Upload' &&
													(introTransitionImageName.toLowerCase().endsWith('.jpg') ||
														introTransitionImageName.toLowerCase().endsWith('.jpeg') ||
														introTransitionImageName.toLowerCase().endsWith('.png'))
												"
												:src="introTransitionTemp"
												width="100%"
												height="200px"
											/>
											<img
												v-else-if="
													entity.introTransition &&
													introTransitionType == 'URL' &&
													$root.isImage(entity.introTransition)
												"
												:src="
													entity.introTransition.toLowerCase().startsWith('http')
														? entity.introTransition
														: baseLocation + '/asset/file/' + entity.introTransition
												"
												width="100%"
												height="200px"
											/>

											<video
												v-else-if="
													introTransitionTemp &&
													introTransitionTemp.startsWith('data') &&
													introTransitionType == 'Upload' &&
													introTransitionImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="200px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="introTransitionTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="
													entity.introTransition &&
													introTransitionType == 'URL' &&
													$root.isVideo(entity.introTransition)
												"
												width="100%"
												height="200px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entity.introTransition.toLowerCase().startsWith('http')
															? entity.introTransition
															: baseLocation + '/asset/file/' + entity.introTransition
													"
													type="video/mp4"
												/>
											</video>
											<div v-else-if="entity.introTransition &&
													introTransitionType == 'URL' && $root.isYoutubeUrl(entity.introTransition)">
												<youtube
													:videoId="$root.getYoutubeId(entity.introTransition, introTransitionYoutubeParams)"
													:player-vars="introTransitionYoutubeParams"
													style="pointer-events: none "
													width="512"
													height="288"
												></youtube>
											</div>
											<vimeo-player 
												v-else-if="entity.introTransition &&
													introTransitionType == 'URL'  && $root.isVimeoUrl(entity.introTransition)"
												:video-url="entity.introTransition"
												:options="introTransition"
												style="pointer-events: none "
												player-width="512"
												player-height="288"
												ref="background"
											></vimeo-player>
											<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
											<!--INPUT FOR INTRO TRANSITION--->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select
														v-model="introTransitionType"
														:items="['Upload', 'URL']"
														label="Intro Transition Type"
													></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="introTransitionType === 'Upload'">
													<input
														ref="attachment2"
														type="file"
														accept="video/mp4"
														@change="onIntroTransitionUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="introTransitionFileName"
														label="Intro Transition (Optional)"
														hint="It’s recommended to use video with resolution of 1080 pixels."
														placeholder="Upload Intro Transition"
														prepend-icon="mdi-image-move"
														@click="openIntroTransitionDialog()"
														readonly
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entity.introTransition"
														prepend-icon="mdi-image-move"
														label="Intro Transition (Optional)"
														placeholder="Intro Transition Url"
														hint="Please input video url with mp4 extension"
													></v-text-field> </v-col
											></v-row>
											<!--END INPUT FOR INTRO TRANSITION--->
										</v-col>
										<v-col class="text-center" cols="12" sm="6">
											<img
												v-if="
													outroTransitionTemp &&
													outroTransitionTemp.startsWith('data') &&
													outroTransitionType == 'Upload' &&
													(outroTransitionImageName.toLowerCase().endsWith('.jpg') ||
														outroTransitionImageName.toLowerCase().endsWith('.jpeg') ||
														outroTransitionImageName.toLowerCase().endsWith('.png'))
												"
												:src="outroTransitionTemp"
												width="100%"
												height="200px"
											/>
											<img
												v-else-if="
													entity.outroTransition &&
													outroTransitionType == 'URL' &&
													$root.isImage(entity.outroTransition)
												"
												:src="
													entity.outroTransition.toLowerCase().startsWith('http')
														? entity.outroTransition
														: baseLocation + '/asset/file/' + entity.outroTransition
												"
												width="100%"
												height="200px"
											/>

											<video
												v-else-if="
													outroTransitionTemp &&
													outroTransitionTemp.startsWith('data') &&
													outroTransitionType == 'Upload' &&
													outroTransitionImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="200px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="outroTransitionTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="
													entity.outroTransition &&
													outroTransitionType == 'URL' &&
													$root.isVideo(entity.outroTransition)
												"
												width="100%"
												height="200px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entity.outroTransition.toLowerCase().startsWith('http')
															? entity.outroTransition
															: baseLocation + '/asset/file/' + entity.outroTransition
													"
													type="video/mp4"
												/>
											</video>
											<div v-else-if="entity.outroTransition &&
													outroTransitionType == 'URL' && $root.isYoutubeUrl(entity.outroTransition)">
												<youtube
													:videoId="$root.getYoutubeId(entity.outroTransition, outroTransitionYoutubeParams)"
													:player-vars="outroTransitionYoutubeParams"
													style="pointer-events: none "
													width="512"
													height="288"
												></youtube>
											</div>
											<vimeo-player 
												v-else-if="entity.outroTransition &&
													outroTransitionType == 'URL'  && $root.isVimeoUrl(entity.outroTransition)"
												:video-url="entity.outroTransition"
												:options="outroTransitionVimeoParams"
												style="pointer-events: none "
												player-width="512"
												player-height="288"
												ref="background"
											></vimeo-player>
											<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
											<!--INPUT FOR OUTRO TRANSITION--->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select
														v-model="outroTransitionType"
														:items="['Upload', 'URL']"
														label="Outro Transition Type"
													></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="outroTransitionType === 'Upload'">
													<input
														ref="attachment3"
														type="file"
														accept="video/mp4"
														@change="onOutroTransitionUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="outroTransitionFileName"
														label="Outro Transition (Optional)"
														hint="It’s recommended to use video with resolution of 1080 pixels."
														placeholder="Upload Outro Transition"
														prepend-icon="mdi-image-move"
														@click="openOutroTransitionDialog()"
														readonly
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entity.outroTransition"
														prepend-icon="mdi-image-move"
														label="Outro Transition (Optional)"
														placeholder="Outro Transition Url"
														hint="Please input video url with mp4 extension"
													></v-text-field> </v-col
											></v-row>
											<!--END INPUT FOR OUTRO TRANSITION--->
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entity.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entity.slug = entity.name ? entity.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entity.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-if="isTargetOne"
											v-model="entity.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-if="!isTargetOne"
											v-model="entity.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entity.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Edit Room Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formEdit" v-model="validEdit" @submit.prevent="editRoomLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col class="text-center" cols="12" sm="6">
											<img
												v-if="
													editBackgroundTemp &&
													editBackgroundTemp.startsWith('data') &&
													backgroundType == 'Upload' &&
													(backgroundImageName.toLowerCase().endsWith('.jpg') ||
														backgroundImageName.toLowerCase().endsWith('.jpeg') ||
														backgroundImageName.toLowerCase().endsWith('.png'))
												"
												:src="editBackgroundTemp"
												width="100%"
											/>
											<img
												v-else-if="entityEdit.background && backgroundType == 'URL' && $root.isImage(entityEdit.background)"
												:src="
													entityEdit.background.toLowerCase().startsWith('http')
														? entityEdit.background
														: baseLocation + '/asset/file/' + entityEdit.background
												"
												width="100%"
											/>

											<video
												v-else-if="
													editBackgroundTemp &&
													editBackgroundTemp.startsWith('data') &&
													backgroundType == 'Upload' &&
													backgroundImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="editBackgroundTemp" type="video/mp4" />
											</video>
											<div v-else-if="entityEdit.background && backgroundType == 'URL' && $root.isVideo(entityEdit.background)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background 
													&& (entityEdit.transitMap.videoUploadStatus.Background === 'ready' || entityEdit.transitMap.videoUploadStatus.Background === 'uploading')" 
													class="icon_vimeo_progress_upload">mdi-progress-upload
												</v-icon>
												<video
													width="100%"
													preload="auto"
													autoplay="autoplay"
													muted
													playsinline
													disablepictureinpicture
													loop="loop"
												>
													<source
														:src="
															entityEdit.background.toLowerCase().startsWith('http')
																? entityEdit.background
																: baseLocation + '/asset/file/' + entityEdit.background
														"
														type="video/mp4"
													/>
												</video>
											</div>
											<div v-else-if="entityEdit.background && backgroundType == 'URL'  && $root.isYoutubeUrl(entityEdit.background)">
												<youtube
													:videoId="$root.getYoutubeId(entityEdit.background, backgroundYoutubeParams)"
													:player-vars="backgroundYoutubeParams"
													style="pointer-events: none "
													width="512"
													height="288"
												></youtube>
											</div>
											<div v-else-if="entityEdit.background && backgroundType == 'URL' && $root.isVimeoUrl(entityEdit.background)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background 
													&& entityEdit.transitMap.videoUploadStatus.Background === 'available'" 
													class="icon_vimeo_succes_upload" small>mdi-vimeo
												</v-icon>
												<vimeo-player 
													:video-url="entityEdit.background"
													:options="backgroundVimeoParams"
													style="pointer-events: none "
													player-width="485"
													player-height="288"
													ref="background"
												></vimeo-player>
											</div>
											<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
											<!--- EDIT BACKGROUND INPUT--->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Background Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundFileName"
														label="Background"
														hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Background"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Room image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entityEdit.background"
														prepend-icon="mdi-image"
														label="Background"
														placeholder="Background Url"
														hint="Please input image url with jpeg/jpg/png extension or video with mp4 extension"
														:rules="[(v) => !!v || 'Room image is required']"
													></v-text-field> </v-col
											></v-row>
											<!--- END OF EDIT BACKGROUND INPUT--->
										</v-col>
										<v-col class="text-center" cols="12" sm="6">
											<img
												v-if="
													editIntroTransitionTemp &&
													editIntroTransitionTemp.startsWith('data') &&
													introTransitionType == 'Upload' &&
													(introTransitionImageName.toLowerCase().endsWith('.jpg') ||
														introTransitionImageName.toLowerCase().endsWith('.jpeg') ||
														introTransitionImageName.toLowerCase().endsWith('.png'))
												"
												:src="editIntroTransitionTemp"
												width="100%"
											/>
											<img
												v-else-if="
													entityEdit.introTransition &&
													introTransitionType == 'URL' &&
													$root.isImage(entityEdit.introTransition)
												"
												:src="
													entityEdit.introTransition.toLowerCase().startsWith('http')
														? entityEdit.introTransition
														: baseLocation + '/asset/file/' + entityEdit.introTransition
												"
												width="100%"
											/>

											<video
												v-else-if="
													editIntroTransitionTemp &&
													editIntroTransitionTemp.startsWith('data') &&
													introTransitionType == 'Upload' &&
													introTransitionImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="editIntroTransitionTemp" type="video/mp4" />
											</video>
											<div v-else-if="entityEdit.introTransition && introTransitionType == 'URL' && $root.isVideo(entityEdit.introTransition)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Intro_Transition 
													&& (entityEdit.transitMap.videoUploadStatus.Intro_Transition === 'ready' || entityEdit.transitMap.videoUploadStatus.Intro_Transition === 'uploading')" 
													class="icon_vimeo_progress_upload">mdi-progress-upload
												</v-icon>
												<video
													width="100%"
													preload="auto"
													autoplay="autoplay"
													muted
													playsinline
													disablepictureinpicture
													loop="loop"
												>
													<source
														:src="
															entityEdit.introTransition.toLowerCase().startsWith('http')
																? entityEdit.introTransition
																: baseLocation + '/asset/file/' + entityEdit.introTransition
														"
														type="video/mp4"
													/>
												</video>
											</div>
											<div v-else-if="entityEdit.introTransition &&
													introTransitionType == 'URL'  && $root.isYoutubeUrl(entityEdit.introTransition)">
												<youtube
													:videoId="$root.getYoutubeId(entityEdit.introTransition, introTransitionYoutubeParams)"
													:player-vars="introTransitionYoutubeParams"
													style="pointer-events: none "
													width="512"
													height="288"
												></youtube>
											</div>
											<div v-else-if="entityEdit.introTransition && introTransitionType == 'URL'   && $root.isVimeoUrl(entityEdit.introTransition)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Intro_Transition 
													&& entityEdit.transitMap.videoUploadStatus.Intro_Transition === 'available'" 
													class="icon_vimeo_succes_upload" small>mdi-vimeo
												</v-icon>
												<vimeo-player 
													:video-url="entityEdit.introTransition"
													:options="introTransitionVimeoParams"
													style="pointer-events: none "
													player-width="485"
													player-height="288"
													ref="introTransition"
												></vimeo-player>
											</div>
											<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
											<!---EDIT INTRO TRANSITION INPUT -->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select
														v-model="introTransitionType"
														:items="['Upload', 'URL']"
														label="Intro Transition Type"
													></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="introTransitionType === 'Upload'">
													<input
														ref="attachment2"
														type="file"
														accept="video/mp4"
														@change="onIntroTransitionUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="introTransitionFileName"
														label="Intro Transition"
														hint="It’s recommended to use video with resolution of 1080 pixels."
														placeholder="Upload Intro Transition"
														prepend-icon="mdi-image"
														@click="openIntroTransitionDialog()"
														readonly
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entityEdit.introTransition"
														prepend-icon="mdi-image-move"
														label="Intro Transition (Optional)"
														placeholder="Intro Transition Url"
														hint="Please input video url with mp4 extension"
													></v-text-field> </v-col
											></v-row>
											<!---END OF EDIT INTRO TRANSITION INPUT -->
										</v-col>
										<v-col class="text-center" cols="12" sm="6">
											<img
												v-if="
													editOutroTransitionTemp &&
													editOutroTransitionTemp.startsWith('data') &&
													outroTransitionType == 'Upload' &&
													(outroTransitionImageName.toLowerCase().endsWith('.jpg') ||
														outroTransitionImageName.toLowerCase().endsWith('.jpeg') ||
														outroTransitionImageName.toLowerCase().endsWith('.png'))
												"
												:src="editOutroTransitionTemp"
												width="100%"
											/>
											<img
												v-else-if="
													entityEdit.outroTransition &&
													outroTransitionType == 'URL' &&
													$root.isImage(entityEdit.outroTransition)
												"
												:src="
													entityEdit.outroTransition.toLowerCase().startsWith('http')
														? entityEdit.outroTransition
														: baseLocation + '/asset/file/' + entityEdit.outroTransition
												"
												width="100%"
											/>

											<video
												v-else-if="
													editOutroTransitionTemp &&
													editOutroTransitionTemp.startsWith('data') &&
													outroTransitionType == 'Upload' &&
													outroTransitionImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="editOutroTransitionTemp" type="video/mp4" />
											</video>
											<div v-else-if="entityEdit.outroTransition && outroTransitionType == 'URL' && $root.isVideo(entityEdit.outroTransition)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Outro_Transition 
													&& (entityEdit.transitMap.videoUploadStatus.Outro_Transition === 'ready' || entityEdit.transitMap.videoUploadStatus.Outro_Transition === 'uploading')" 
													class="icon_vimeo_progress_upload">mdi-progress-upload
												</v-icon>
												<video
													width="100%"
													preload="auto"
													autoplay="autoplay"
													muted
													playsinline
													disablepictureinpicture
													loop="loop"
												>
													<source
														:src="
															entityEdit.outroTransition.toLowerCase().startsWith('http')
																? entityEdit.outroTransition
																: baseLocation + '/asset/file/' + entityEdit.outroTransition
														"
														type="video/mp4"
													/>
												</video>
											</div>
											<div v-else-if="entityEdit.outroTransition &&
													outroTransitionType == 'URL' && $root.isYoutubeUrl(entityEdit.outroTransition)">
												<youtube
													:videoId="$root.getYoutubeId(entityEdit.outroTransition, outroTransitionYoutubeParams)"
													:player-vars="outroTransitionYoutubeParams"
													style="pointer-events: none "
													width="512"
													height="288"
												></youtube>
											</div>
											<div v-else-if="entityEdit.outroTransition && outroTransitionType == 'URL' && $root.isVimeoUrl(entityEdit.outroTransition)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Outro_Transition 
													&& entityEdit.transitMap.videoUploadStatus.Outro_Transition === 'available'" 
													class="icon_vimeo_succes_upload" small>mdi-vimeo
												</v-icon>
												<vimeo-player 
													:video-url="entityEdit.outroTransition"
													:options="outroTransitionVimeoParams"
													style="pointer-events: none "
													player-width="485"
													player-height="288"
													ref="background"
												></vimeo-player>
											</div>
											<div v-else style="border: 5px solid black; width: 100%; height: 200px"></div>
											<!---EDIT OUTRO TRANSITION INPUT -->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select
														v-model="outroTransitionType"
														:items="['Upload', 'URL']"
														label="Outro Transition Type"
													></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="outroTransitionType === 'Upload'">
													<input
														ref="attachment3"
														type="file"
														accept="video/mp4"
														@change="onOutroTransitionUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="outroTransitionFileName"
														label="Outro Transition"
														hint="It’s recommended to use video with resolution of 1080 pixels."
														placeholder="Upload Outro Transition"
														prepend-icon="mdi-image"
														@click="openOutroTransitionDialog()"
														readonly
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entityEdit.outroTransition"
														prepend-icon="mdi-image-move"
														label="Outro Transition (Optional)"
														placeholder="Outro Transition Url"
														hint="Please input video url with mp4 extension"
													></v-text-field> </v-col
											></v-row>
											<!---END OF EDIT OUTRO TRANSITION INPUT -->
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entityEdit.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entityEdit.slug = entityEdit.name ? entityEdit.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entityEdit.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-if="isTargetOne"
											v-model="entityEdit.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-if="!isTargetOne"
											v-model="entityEdit.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entityEdit.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!validEdit" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLinkTo" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Default Banner Slot
					<v-spacer></v-spacer>
					<v-btn icon @click="closeLinkTo()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<div class="d-flex">
						<div class="ma-1">
							<v-card class="pa-3">
								<div
									@mousedown="startDrag"
									@mousemove="getPosition($event)"
									style="position: relative; width: 960px; min-width: 960px; background-color: rgba(0, 0, 0, 0.2); line-height: 1.5"
									ref="box"
									id="box"
								>
									<img
										v-if="
											entityEdit.background &&
											(entityEdit.background.toLowerCase().endsWith('.jpg') ||
												entityEdit.background.toLowerCase().endsWith('.jpeg') ||
												entityEdit.background.toLowerCase().endsWith('.png'))
										"
										:src="
											entityEdit.background.toLowerCase().startsWith('http')
												? entityEdit.background
												: baseLocation + '/asset/file/' + entityEdit.background
										"
										width="100%"
										draggable="false"
									/>
									<video
										v-else-if="entityEdit.background && entityEdit.background.toLowerCase().endsWith('.mp4')"
										width="100%"
										preload="auto"
										autoplay="autoplay"
										muted
										playsinline
										disablepictureinpicture
										loop="loop"
										draggable="false"
									>
										<source
											:src="
												entityEdit.background.toLowerCase().startsWith('http')
													? entityEdit.background
													: baseLocation + '/asset/file/' + entityEdit.background
											"
											type="video/mp4"
										/>
									</video>
									<div v-for="(item, index) in entityEdit.linkToDataList" :key="index">
										<router-link
											class="structure-link"
											to="#"
											:style="{
												zIndex: 3,
												width: item.width + '%',
												height: item.height + '%',
												top: item.posY + '%',
												left: item.posX + '%',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)'
											}"
										></router-link>
									</div>
									<div
										v-if="newLinkTo.width && newLinkTo.height && newLinkTo.posX && newLinkTo.posY"
										:style="{
											zIndex: 2,
											width: newLinkTo.width + 'px',
											height: newLinkTo.height + 'px',
											top: newLinkTo.posY + 'px',
											left: newLinkTo.posX + 'px',
											transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
											position: 'absolute',
											pointerEvents: 'none',
											border: newLinkTo.border,
											backgroundColor: 'rgba(245, 229, 27, .5)'
										}"
									></div>
									<div v-if="resize.status">
										<div v-for="(point, index) in resize.points" :key="index">
											<div
												:style="{
													zIndex: 3,
													width: '10px',
													height: '10px',
													top: point.y + 'px',
													left: point.x + 'px',
													transform: 'skew(' + newLinkTo.skewX + 'deg,' + newLinkTo.skewY + 'deg)',
													position: 'absolute',
													pointerEvents: 'none',
													border: '1px solid black',
													backgroundColor: '#BDBDBD'
												}"
											></div>
										</div>
									</div>
									<div style="display: none">
										<v-row>
											<v-col>
												<v-text-field
													class="mb-n9"
													readonly
													v-model="posX"
													label="Position X (%)"
													dense
													outlined
												></v-text-field>
											</v-col>
											<v-col>
												<v-text-field
													class="mb-n9"
													readonly
													v-model="posY"
													label="Position Y (%)"
													dense
													outlined
												></v-text-field>
											</v-col>
										</v-row>
									</div>
								</div>
							</v-card>
						</div>

						<div class="ma-1" style="width: 300px; min-width: 300px">
							<v-card id="linkTo">
								<v-card-text>
									<v-row>
										<v-col cols="12" class="my-n4">
											<v-select
												v-model="newLinkTo.type"
												:items="linkTypes"
												label="Link Type"
												@change="newLinkTo.value = null"
												dense
												outlined
											>
												<template v-slot:selection="{ item }">
													<span>{{ $root.convertLinkTypeLabel(item) }}</span>
												</template>
												<template v-slot:item="{ item }">
													<span>{{ $root.convertLinkTypeLabel(item) }}</span>
												</template>
											</v-select>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.posX" label="X" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.posY" label="Y" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.width" label="Width" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.height" label="Height" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.skewX" label="Skew X" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newLinkTo.skewY" label="Skew Y" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" class="text-right">
											<v-btn
												color="primary"
												@click="
													addLinkTo(entityEdit);
													isEditLinkTo = false;
												"
												>Add</v-btn
											>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</div>
					</div>
					<v-form ref="formLinkTo" v-model="validLinkTo" @submit.prevent="editStructureLinkTo">
						<v-card>
							<v-card-text>
								<v-simple-table>
									<template v-slot:default>
										<thead>
											<tr>
												<th style="width: 20%">Type</th>
												<th style="width: 20%">Position</th>
												<th style="width: 10%">Action</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in entityEdit.linkToDataList" :key="index">
												<td>{{ $root.convertLinkTypeLabel(item.type) }}</td>
												<td>
													<v-row>{{ "W : " + item.width + "% H : " + item.height + "%" }}</v-row>
													<v-row>{{ "X : " + item.posX + "% Y : " + item.posY + "%" }}</v-row>
													<v-row>{{ "Skew X : " + (item.skewX ? item.skewX : "0") + " deg" }}</v-row>
													<v-row>{{ "Skew Y : " + (item.skewY ? item.skewY : "0") + " deg" }}</v-row>
												</td>
												<td>
													<v-btn @click="editLinkTo(entityEdit, item.id)" color="primary" icon>
														<v-icon>mdi-pencil</v-icon>
													</v-btn>
													<v-btn @click="deleteLinkTo(entityEdit, item.id)" color="red" icon>
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card-text>
							<v-card-actions class="d-flex justify-end">
								<v-btn @click="closeLinkTo()" text depressed tile>Close</v-btn>
								<v-btn :disabled="!validLinkTo" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
#structure-view .entry-view {
	max-width: 100%;
	margin: 0 auto;
}
.entry-view {
	position: relative;
}
.structure-link {
	cursor: pointer;
	position: absolute;
}
.longtext {
	max-width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.icon_vimeo_succes_upload {
	color: white; 
	background-color: rgb(38, 185, 241); 
	border-radius: 25px;
	width: 25px;
	height: 25px;
	padding-top: 4px;
	align-items: flex-start;
}
.icon_vimeo_progress_upload {
	color: #f00; 
	align-items: flex-start;
}
</style>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			validEdit: true,
			dialogAdd: false,
			dialogEdit: false,
			roomLibraryList: { data: [], page: 1, size: 8, length: 0, total: 0 },
			entity: { dataMap: {}, linkToDataList: [], planList: [] },
			entityEdit: { planList: [], dataMap: {}, linkToDataList: [] },
			backgroundType: "Upload",
			introTransitionType: "Upload",
			outroTransitionType: "Upload",
			attachment1: null,
			attachment2: null,
			attachment3: null,
			baseLocation: axios.defaults.baseURL,
			tenantPlanList: [],
			tenantList: [],
			backgroundFileName: "",
			introTransitionFileName: "",
			outroTransitionFileName: "",
			backgroundImageName: "",
			introTransitionImageName: "",
			outroTransitionImageName: "",
			editBackgroundTemp: "",
			editIntroTransitionTemp: "",
			editOutroTransitionTemp: "",
			backgroundTemp: "",
			introTransitionTemp: "",
			outroTransitionTemp: "",
			isTargetOne: false,
			dialogLinkTo: false,
			x: null,
			y: null,
			posX: null,
			posY: null,
			draggingStatus: null,
			isEditLinkTo: false,
			newLinkTo: { backgroundColor: "#FF00FFFF", borderColor: "#FF00FFFF" },
			validLinkTo: true,
			linkTypes: [],
			tagList: [],
			tagFilter: [],
			planFilter: [],
			resize: {
				status: false,
				indexActive: -1,
				points: [
					{ x: 0, y: 0, cursor: "nw-resize" },
					{ x: 0, y: 0, cursor: "n-resize" },
					{ x: 0, y: 0, cursor: "ne-resize" },
					{ x: 0, y: 0, cursor: "w-resize" },
					{ x: 0, y: 0, cursor: "e-resize" },
					{ x: 0, y: 0, cursor: "sw-resize" },
					{ x: 0, y: 0, cursor: "s-resize" },
					{ x: 0, y: 0, cursor: "se-resize" }
				]
			},
			rowsPerPage: [8, 16, 32, 64],
			introTransitionYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			outroTransitionYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true},
			introTransitionVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true},
			outroTransitionVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true}
		};
	},
	mounted() {
		this.listRoomLibrary();
		this.listTenantPlan();
		this.listTenant();
		this.listLinkType();
		this.listTag();
		window.addEventListener("mouseup", this.stopDrag);
	},
	methods: {
		listTag() {
			axios.get("/system/roomlibrary/tag/list").then((response) => {
				this.tagList = response.data;
			});
		},
		listRoomLibrary() {
			axios
				.post("/system/roomlibrary/list", {
					planFilter: this.planFilter,
					tagFilter: this.tagFilter,
					tenantPlanId: null,
					page: this.roomLibraryList.page,
					size: this.roomLibraryList.size
				})
				.then((response) => {
					this.roomLibraryList = response.data;
					// Check if small asset is exist and use it
					let vm = this;
					this.roomLibraryList.data.map((obj) => {
						vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function (status) {
							if (status) {
								obj.background = vm.$root.smallAsset(obj.background);
							}
						});
						return obj;
					});
					this.entity.planList = [];
					this.entity.targetId = null;

					this.$nextTick(() => {
						if (this.$vuetify.breakpoint.mobile){
							this.$root.playYoutube(this.$refs.backgroundIndexYoutube);
						}
					});
				});
		},
		resetRoomLibraryFilter() {
			this.planFilter = [];
			this.tagFilter = [];
			this.roomLibraryList.page = 1;
			this.roomLibraryList.size = 8;
			this.listRoomLibrary();
		},
		listLinkType() {
			axios.get("/system/enumeration/linktype/list").then((response) => {
				this.linkTypes = response.data.filter((item) => {
					return ["Attend_Consultation"].indexOf(item) === -1;
				});
				this.linkTypes.sort((a, b) => (a > b ? 1 : -1));
			});
		},
		deleteRoomLibrary(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/roomlibrary/delete", { id: id }).then(() => {
					this.listRoomLibrary();
				});
			}
		},
		addRoomLibrary() {
			if (this.isTargetOne) {
				this.entity.planList = [];
			} else {
				this.entity.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}

			axios.post("/system/roomlibrary/add", formData).then(() => {
				this.listRoomLibrary();
				this.listTag();
				this.entity = {
					dataMap: {},
					linkToDataList: []
				};
				this.$refs.formAdd.reset();
				this.clearData();
				this.dialogAdd = false;
			});
		},
		editRoomLibrary() {
			if (this.isTargetOne) {
				this.entityEdit.planList = [];
			} else {
				this.entityEdit.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}

			axios.post("/system/roomlibrary/edit", formData).then(() => {
				this.listRoomLibrary();
				this.listTag();
				this.entityEdit = {
					dataMap: {},
					linkToDataList: []
				};
				this.$refs.formEdit.reset();
				this.clearData();
				this.dialogEdit = false;
			});
		},
		showAdd() {
			this.backgroundType = "Upload";
			this.introTransitionType = "Upload";
			this.outroTransitionType = "Upload";
			this.entity = {
				dataMap: {},
				linkToDataList: []
			};
			this.dialogAdd = true;
		},
		showEdit(item) {
			this.entityEdit = { ...item };
			this.isTargetOne = this.entityEdit.targetId ? true : false;
			if (this.entityEdit.background) {
				this.entityEdit.background = this.$root.reverseToOriginal(this.entityEdit.background);
			}
			if (this.entityEdit.dataMap.bannerRotatingVideo) {
				this.bannerRotatingVideoType = "URL";
			} else {
				this.bannerRotatingVideoType = "Upload";
			}
			if (this.entityEdit.background) {
				this.backgroundType = "URL";
			} else {
				this.backgroundType = "Upload";
			}
			if (this.entityEdit.introTransition) {
				this.introTransitionType = "URL";
			} else {
				this.introTransitionType = "Upload";
			}
			if (this.entityEdit.outroTransition) {
				this.outroTransitionType = "URL";
			} else {
				this.outroTransitionType = "Upload";
			}
			this.dialogEdit = true;
		},
		showLinkTo(item) {
			this.entityEdit = item;
			this.dialogLinkTo = true;
			if (!this.entityEdit.linkToDataList) {
				this.id = 0;
				this.entityEdit.linkToDataList = [];
			} else {
				this.id = this.entityEdit.linkToDataList.length;
			}
		},
		closeLinkTo() {
			this.entityEdit = {
				mainStructure: false,
				dataMap: {},
				linkToDataList: []
			};
			this.$refs.formLinkTo.reset();
			this.newLinkTo = { backgroundColor: "#FF00FFFF", borderColor: "#FF00FFFF" };
			this.dialogLinkTo = false;
			this.$refs.formLinkTo.reset();
		},
		getPosition(event) {
			event.preventDefault();
			if (this.draggingStatus == "draw") {
				this.newLinkTo.posX = this.x;
				this.newLinkTo.posY = this.y;
				if (event.offsetX - this.newLinkTo.posX >= 1) {
					this.newLinkTo.width = event.offsetX - this.newLinkTo.posX;
					this.newLinkTo.height = event.offsetY - this.newLinkTo.posY;
				}
			} else if (this.draggingStatus == "dragAndDrop") {
				let x = parseFloat(this.x) - parseFloat(event.offsetX);
				let y = parseFloat(this.y) - parseFloat(event.offsetY);
				let widthCanvas = this.entityEdit.background && this.entityEdit.background.toLowerCase().endsWith(".mp4") ? 960 : event.target.width;
				let heightCanvas =
					this.entityEdit.background && this.entityEdit.background.toLowerCase().endsWith(".mp4") ? 540 : event.target.height;

				if (this.isInZone(x, y, widthCanvas, heightCanvas)) {
					this.newLinkTo.posX = parseFloat(this.newLinkTo.posX) - x;
					this.newLinkTo.posY = parseFloat(this.newLinkTo.posY) - y;
					this.x = event.offsetX;
					this.y = event.offsetY;
				}
				this.showResize();
			} else if (this.draggingStatus == "resize") {
				if (this.resize.indexActive == 0) {
					this.resizeTop(event);
					this.resizeLeft(event);
				} else if (this.resize.indexActive == 1) {
					this.resizeTop(event);
				} else if (this.resize.indexActive == 2) {
					this.resizeTop(event);
					this.resizeRight(event);
				} else if (this.resize.indexActive == 3) {
					this.resizeLeft(event);
				} else if (this.resize.indexActive == 4) {
					this.resizeRight(event);
				} else if (this.resize.indexActive == 5) {
					this.resizeBottom(event);
					this.resizeLeft(event);
				} else if (this.resize.indexActive == 6) {
					this.resizeBottom(event);
				} else if (this.resize.indexActive == 7) {
					this.resizeBottom(event);
					this.resizeRight(event);
				}
				this.x = event.offsetX;
				this.y = event.offsetY;
				this.showResize();
			}
			this.posX = event.offsetX;
			this.posY = event.offsetY;
		},
		startDrag(event) {
			let x1 = this.newLinkTo.posX;
			let x2 = parseInt(this.newLinkTo.width) + parseInt(this.newLinkTo.posX);
			let y1 = this.newLinkTo.posY;
			let y2 = parseInt(this.newLinkTo.posY) + parseInt(this.newLinkTo.height);

			if (x1 <= event.offsetX && x2 >= event.offsetX && y1 <= event.offsetY && y2 >= event.offsetY) {
				this.draggingStatus = "dragAndDrop";
				this.showResize();
				this.resize.indexActive = -1;
				this.newLinkTo.border = "1px dashed black";
			} else if (this.isResize(event.offsetX, event.offsetY)) {
				this.draggingStatus = "resize";
			} else {
				this.draggingStatus = "draw";
				this.resize.status = false;
				this.resize.indexActive = -1;
				this.newLinkTo.border = "1px solid #76FF03";
			}
			this.x = event.offsetX;
			this.y = event.offsetY;
		},
		stopDrag() {
			this.draggingStatus = null;
		},
		isInZone(x, y, widthCanvas, heightCanvas) {
			let x2 = parseInt(this.newLinkTo.posX) + parseInt(this.newLinkTo.width);
			let y2 = parseInt(this.newLinkTo.posY) + parseInt(this.newLinkTo.height);

			if (x < 0 && x2 > widthCanvas - 10) {
				this.newLinkTo.posX = widthCanvas - 10 - parseInt(this.newLinkTo.width);
				return false;
			} else if (x > 0 && parseInt(this.newLinkTo.posX) < 10) {
				this.newLinkTo.posX = 10;
				return false;
			}
			if (y < 0 && y2 > heightCanvas - 10) {
				this.newLinkTo.posY = heightCanvas - 10 - parseInt(this.newLinkTo.height);
				return false;
			} else if (y > 0 && parseInt(this.newLinkTo.posY) < 10) {
				this.newLinkTo.posY = 10;
				return false;
			}
			return true;
		},
		resizeLeft(event) {
			let width = parseInt(this.newLinkTo.width) + parseInt(this.x) - parseInt(event.offsetX);
			if (width >= 20) {
				this.newLinkTo.width = width;
				this.newLinkTo.posX = parseInt(this.newLinkTo.posX) - (parseInt(this.x) - parseInt(event.offsetX));
			}
		},
		resizeTop(event) {
			let height = parseInt(this.newLinkTo.height) + (parseInt(this.y) - parseInt(event.offsetY));
			if (height >= 20) {
				this.newLinkTo.height = height;
				this.newLinkTo.posY = parseInt(this.newLinkTo.posY) - (parseInt(this.y) - parseInt(event.offsetY));
			}
		},
		resizeRight(event) {
			let width = parseInt(this.newLinkTo.width) - (parseInt(this.x) - parseInt(event.offsetX));
			if (width >= 20) {
				this.newLinkTo.width = width;
			}
		},
		resizeBottom(event) {
			let height = parseInt(this.newLinkTo.height) - (parseInt(this.y) - parseInt(event.offsetY));
			if (height >= 20) {
				this.newLinkTo.height = height;
			}
		},
		showResize() {
			let x1 = parseInt(this.newLinkTo.posX);
			let x2 = parseInt(this.newLinkTo.width) + parseInt(this.newLinkTo.posX);
			let y1 = parseInt(this.newLinkTo.posY);
			let y2 = parseInt(this.newLinkTo.posY) + parseInt(this.newLinkTo.height);
			let centerX = parseFloat(this.newLinkTo.width) / 2 + parseFloat(this.newLinkTo.posX);
			let centerY = parseFloat(this.newLinkTo.posY) + parseFloat(this.newLinkTo.height) / 2;

			this.resize.status = true;

			this.resize.points[0].x = x1 - 10;
			this.resize.points[0].y = y1 - 10;
			this.resize.points[1].x = centerX - 5;
			this.resize.points[1].y = y1 - 10;
			this.resize.points[2].x = x2;
			this.resize.points[2].y = y1 - 10;

			this.resize.points[3].x = x1 - 10;
			this.resize.points[3].y = centerY - 5;
			this.resize.points[4].x = x2;
			this.resize.points[4].y = centerY - 5;

			this.resize.points[5].x = x1 - 10;
			this.resize.points[5].y = y2;
			this.resize.points[6].x = centerX - 5;
			this.resize.points[6].y = y2;
			this.resize.points[7].x = x2;
			this.resize.points[7].y = y2;
		},
		isResize(x, y) {
			for (let i = 0; i < this.resize.points.length; i++) {
				let x1 = parseInt(this.resize.points[i].x);
				let x2 = parseInt(this.resize.points[i].x) + 10;
				let y1 = parseInt(this.resize.points[i].y);
				let y2 = parseInt(this.resize.points[i].y) + 10;

				if (x1 <= x && x2 >= x && y1 <= y && y2 >= y) {
					this.resize.indexActive = i;
					return true;
				}
			}
			this.resize.indexActive = -1;
			return false;
		},
		addLinkTo(entity) {
			if (this.backgroundType === "Upload" && this.attachment1) {
				let formData = new FormData();
				formData.append("attachment1", this.attachment1);
				formData.append("experienceId", JSON.stringify(this.entityEdit.experienceId));
				formData.append("structureId", JSON.stringify(this.entityEdit.id));
				axios.post("/system/structure/linkto/image", formData).then((response) => {
					this.newLinkTo.value = response.data;
					this.attachment1 = null;
				});
			}

			this.newLinkTo.id = this.newLinkTo.id ? this.newLinkTo.id : ++this.id;
			if (this.newLinkTo.type && this.newLinkTo.posX && this.newLinkTo.posY && this.newLinkTo.width && this.newLinkTo.height) {
				entity.linkToDataList.push(this.newLinkTo);
				this.newLinkTo = { backgroundColor: "#FF00FFFF", borderColor: "#FF00FFFF" };
			}
		},
		editLinkTo(entity, id) {
			document.getElementById("linkTo").scrollIntoView({ behavior: "smooth" });
			let list = entity.linkToDataList;
			for (let i in list) {
				if (list[i].id === id) {
					this.newLinkTo = list[i];
					list.splice(i, 1);
					this.isEditLinkTo = true;
					this.resize.status = false;
					return;
				}
			}
		},
		deleteLinkTo(entity, id) {
			let list = entity.linkToDataList;
			for (let i in list) {
				if (list[i].id === id) {
					list.splice(i, 1);
					return;
				}
			}
		},
		editStructureLinkTo() {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));

			axios
				.post("/system/roomlibrary/edit/linkto", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					console.log("test");
				});
		},
		closeAdd() {
			this.entity = {
				dataMap: {},
				linkToDataList: []
			};
			this.dialogAdd = false;
			this.$refs.formAdd.reset();
			this.clearData();
		},
		closeEdit() {
			this.entityEdit = {
				mainStructure: false,
				dataMap: {},
				linkToDataList: []
			};
			this.dialogEdit = false;
			this.$refs.formEdit.reset();
			this.clearData();
		},
		listTenantPlan() {
			axios.get("/system/tenantplan/list").then((response) => {
				this.tenantPlanList = response.data;
			});
		},
		listTenant() {
			axios.get("/system/tenant/list").then((response) => {
				this.tenantList = response.data;
			});
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundTemp = fr.result;
					} else {
						this.editBackgroundTemp = fr.result;
					}
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundImageName = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		onIntroTransitionUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.introTransitionTemp = fr.result;
					} else {
						this.editIntroTransitionTemp = fr.result;
					}
					this.attachment2 = files[0]; // this is an image file that can be sent to server...
				});
				this.introTransitionFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.introTransitionImageName = files[0].name;
			} else {
				this.attachment2 = null;
			}
		},
		onOutroTransitionUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.outroTransitionTemp = fr.result;
					} else {
						this.editOutroTransitionTemp = fr.result;
					}
					this.attachment3 = files[0]; // this is an image file that can be sent to server...
				});
				this.outroTransitionFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.outroTransitionImageName = files[0].name;
			} else {
				this.attachment3 = null;
			}
		},
		openBackgroundDialog() {
			this.$refs.attachment1.click();
		},
		openIntroTransitionDialog() {
			this.$refs.attachment2.click();
		},
		openOutroTransitionDialog() {
			this.$refs.attachment3.click();
		},
		clearData() {
			this.attachment1 = null;
			this.attachment2 = null;
			this.attachment3 = null;
			this.backgroundFileName = "";
			this.introTransitionFileName = "";
			this.outroTransitionFileName = "";
			this.backgroundImageName = "";
			this.introTransitionImageName = "";
			this.outroTransitionImageName = "";
			this.editBackgroundTemp = "";
			this.editIntroTransitionnTemp = "";
			this.backgroundTemp = "";
			this.introTransitionTemp = "";
			this.outroTransitionTemp = "";
		}
	}
};
</script>
